export default {
  SET_LOADING(state, key, ownerProfileId = undefined) {
    switch (key) {
      case 'folders': {
        state.loading.folders[ownerProfileId] = true
        break
      }
      default: {
        state.loading[key] = true
      }
    }
  },
  CLEAR_LOADING(state, key, ownerProfileId = undefined) {
    switch (key) {
      case 'folders': {
        state.loading.folders[ownerProfileId] = false
        break
      }
      default: {
        state.loading[key] = false
      }
    }
  },
  SET_INSERTION_ORDERS(state, insertionOrders) {
    state.insertionOrders = insertionOrders
  },
  SET_FOLDERS(state, { ownerProfileId, folders }) {
    state.folders[ownerProfileId] = folders
  },
  SET_CREATIVES(state, creatives) {
    state.creatives = creatives
  },
  SET_CURRENT_RESOURCE(state, resource) {
    state.currentResource = resource
  },
  SET_CURRENT_FOLDER(state, folder) {
    state.currentFolder = folder
  },
  SET_CURRENT_CREATIVE(state, creative) {
    state.currentCreative = creative
  },
  SET_SEARCH_KEYWORD(state, keyword) {
    state.searchKeyword = keyword
  },
  SET_SELECTED_CREATIVE_TYPES(state, selectedCreativeTypes) {
    state.selectedCreativeTypes = selectedCreativeTypes
  },
  SET_SELECTED_AUDIT_STATUSES(state, selectedAuditStatuses) {
    state.selectedAuditStatuses = selectedAuditStatuses
  },
  SET_SEARCH_PAGE_NO(state, pageNo) {
    state.pageNo = pageNo
  },
  SET_SEARCH_PAGE_SIZE(state, pageSize) {
    state.pageSize = pageSize
  },
  UPDATE_SORT_OPTIONS(state, { sortBy, descending }) {
    state.sortOptions.sortBy = sortBy
    state.sortOptions.descending = descending
  },
  SET_SELECTED_CREATIVES(state, selectedCreatives) {
    state.selectedCreatives = selectedCreatives
  },
  RESET(state) {
    state.insertionOrders = []
    state.folders = []
    state.creatives = {}
    state.currentResource = null // 開いているフォルダーの所属リソース
    state.currentFolder = null
    state.currentCreative = null
    state.loading = {
      insertionOrders: false,
      folders: [], // ownerProfileId が index
      creatives: false,
    }
    state.selectedCreatives = []
    state.selectedCreativeTypes = null
    state.searchKeyword = ''
  },
}
